export const settingsConfig = {
  searchPaymentFilter: [
    {
      label: 'Select Payment Type',
      value: '',
    },
    {
      value: "APP_PROCESSING_FEE",
      label: "Application Processing Fee"
    },
    {
      value: "WORK_PERMIT_FEE",
      label: "Work Permit Fee"
    },
  ],
  searchStatusFilter: [
    {
      label: 'Select Status',
      value: '',
    },
    {
      value: "SUCCESS",
      label: "Success"
    },
    {
      value: "PROCESSING",
      label: "Processing"
    },
    {
      value: "AUTHORIZED",
      label: "Authorized"
    },
    {
      value: "FAILED",
      label: "Failed"
    }
  ],
  tableHeaders: [
    {
      key: 'Email',
      filterTypes: [
        {
          label: 'Contains',
          type: 'text',
          id: 'email',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'email',
        },
      ],
    },
    {
      key: 'First Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'firstName',
        },
      ],
    },
    {
      key: 'Last Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'lastName',
        },
      ],
    },
  ],
};
